import { useRef, useEffect, useState } from "react";
import Pagination from "../../../../Components/Pagination";
import Button from "../../../../Core/Button/Button";
import GetIcon from "../../../../utils/Icon";

const Table1 = ({ setselected_item_data,initialData  }) => {
    // Create initial row data structure
 const createNewRow = () => ({
    email: "",
    is_primary: false,
  });

  const normalizeInitialData = (data) => {
    if (!data || !Array.isArray(data)) return [createNewRow()];
    return data.map((item) => ({
      email: item.email || "",
      is_primary: Boolean(item.is_primary),
    }));
  };

  const [rows, setRows] = useState([createNewRow()]); // initialize with one empty row

  // Update rows when initialData changes
  useEffect(() => {
    if (initialData && Array.isArray(initialData)) {
      const normalized = normalizeInitialData(initialData);
      setRows(normalized);
    }
  }, [initialData]);

  // Send updated rows to parent
  useEffect(() => {
    setselected_item_data(rows);
  }, [rows, setselected_item_data]);
    // const [rows, setRows] = useState(initialData && initialData.length > 0 ? initialData : [createNewRow()]);
    // Refs and state management
    const tableRef = useRef();
    const [rowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    // const [rows, setRows] = useState([createNewRow()]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [focusedCell, setFocusedCell] = useState({ rowIndex: null, field: null });

    // Calculate pagination values
    const isAllSelected = rows.length > 0 && selectedRows.length === rows.length;
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = rows.slice(indexOfFirstRow, indexOfLastRow);

    // Select all rows handler
    const handleSelectAll = (e) => {
        if (e.target.checked) {
            const allRowIndices = rows.map((_, index) => index);
            setSelectedRows(allRowIndices);
        } else {
            setSelectedRows([]);
        }
    };

    // Update row data
    const updateRow = (index, field, value) => {
        console.log(index, field, value, "index, field, value");

        const updatedRows = [...rows];
        updatedRows[index][field] = value;
        
        if (field === 'is_primary' && value === true) {
            updatedRows.forEach((row, i) => {
                if (i !== index) row.is_primary = false;
            });
        }

        setselected_item_data(updatedRows)
        setRows(updatedRows);

    };

    // Toggle row selection
    const toggleRowSelection = (index) => {
        setSelectedRows((prev) =>
            prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
        );
    };

    // Add new row
    const handleAddRow = () => {
        const newRows = [...rows, createNewRow()];
        setRows(newRows);
        setselected_item_data(newRows);
        const lastPage = Math.ceil(newRows.length / rowsPerPage);
        if (currentPage !== lastPage) {
            setCurrentPage(lastPage);
        }
    };

    // Delete selected rows
    const handleDeleteSelectedRows = () => {
        const updatedRows = rows.filter((_, idx) => !selectedRows.includes(idx));
        setRows(updatedRows);
        setselected_item_data(updatedRows);
        setSelectedRows([]);
        const lastPage = Math.ceil(updatedRows.length / rowsPerPage);
        if (currentPage > lastPage) {
            setCurrentPage(lastPage);
        }
    };

    // Set up column resizing
    useEffect(() => {
        const cols = tableRef.current?.querySelectorAll("th");
        if (!cols) return;

        cols.forEach((col) => {
            const resizer = document.createElement("div");
            resizer.className = "resizer";
            col.appendChild(resizer);

            let x = 0;
            let w = 0;

            const onMouseDown = (e) => {
                x = e.clientX;
                w = col.offsetWidth;
                document.addEventListener("mousemove", onMouseMove);
                document.addEventListener("mouseup", onMouseUp);
            };

            const onMouseMove = (e) => {
                const dx = e.clientX - x;
                col.style.width = `${w + dx}px`;
            };

            const onMouseUp = () => {
                document.removeEventListener("mousemove", onMouseMove);
                document.removeEventListener("mouseup", onMouseUp);
            };

            resizer.addEventListener("mousedown", onMouseDown);
        });
    }, []);

    return (
        <div className="row" style={{ border: "1px solid #00000059", borderRadius: "5px", marginBottom: '20px' }}>
            <div className="col-12">
                <p className="boxLabel m-0">Email IDs</p>
            </div>
            <div className="">
                <table className="table table-bordered mb-1" ref={tableRef}>
                    <thead className="tableHead1">
                        <tr>
                            {[ "S.No", "Email ID", "Is Primary", "Settings"].map((title, i) => {
                                const defaultWidths = {
                                    "Action": "20px",
                                    "S.No": "10px",
                                    "Email ID": "250px",
                                    "Is Primary": "100px",
                                    "Settings": "80px"
                                };

                                return (
                                    <th
                                        key={i}
                                        style={{
                                            fontSize: '7px',
                                            position: "relative",
                                            textAlign: title === "Action" || title === "S.No" || title === "Settings" || title === "Is Primary" ? "center" : "left",
                                            width: defaultWidths[title] || "150px",
                                            minWidth: defaultWidths[title] || "150px",
                                        }}
                                    >
                                        {title === "Settings" ? (
                                            <GetIcon iconName="IoSettingsOutline"
                                                style={{



                                                    fontSize: '15px',

                                                }}
                                                size={15} />
                                        ) : title === "Action" ? (
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                style={{
                                                    backgroundColor: isAllSelected ? "#270b79" : "",
                                                    borderColor: isAllSelected ? "#270b79" : "",
                                                    fontSize: '15px'
                                                }}
                                                checked={isAllSelected}
                                                onChange={handleSelectAll}
                                            />
                                        ) : (
                                            title
                                        )}

                                    </th>
                                );
                            })}
                        </tr>
                    </thead>

                    <tbody>
                        {currentRows.map((row, index) => {
                            const globalIndex = indexOfFirstRow + index;
                            return (
                                <tr key={globalIndex}>
                                    {/* Action (Checkbox) */}
                                    {/* <td className="p-0" style={{ cursor: 'pointer', textAlign: 'center' }}>
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            style={{
                                                backgroundColor: selectedRows.includes(globalIndex) ? "#270b79" : "",
                                                borderColor: selectedRows.includes(globalIndex) ? "#270b79" : "",
                                                fontSize: '15px'
                                            }}
                                            checked={selectedRows.includes(globalIndex)}
                                            onChange={() => toggleRowSelection(globalIndex)}
                                        />
                                    </td> */}

                                    {/* S.No */}
                                    <td style={{ textAlign: "center", fontSize: '0.8rem' }}>
                                        {globalIndex + 1}
                                    </td>

                                    {/* Email ID */}
                                    <td className="p-0" style={{
                                        border: focusedCell.rowIndex === globalIndex && focusedCell.field === 'email' ? '0.3px solid #270b79' : ''
                                    }}>
                                        <input
                                            type="email"
                                            className="form-control tableinput noborder"
                                            style={{ fontSize: '0.8rem' }}
                                            // onFocus={() => setFocusedCell({ rowIndex: globalIndex, field: 'email' })}
                                            // onBlur={() => setFocusedCell({ rowIndex: null, field: null })}
                                            value={row.email}
                                            onChange={(e) => updateRow(globalIndex, "email", e.target.value)}
                                            readOnly
                                        />
                                    </td>

                                    {/* Is Primary (Checkbox) */}
                                    <td className="p-0" style={{ textAlign: 'center' }}>
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            style={{
                                                backgroundColor: row.is_primary ? "#270b79" : "",
                                                borderColor: row.is_primary ? "#270b79" : "",
                                                fontSize: '15px'
                                            }}
                                            checked={row.is_primary}
                                            onChange={(e) => updateRow(globalIndex, "is_primary", e.target.checked)}
                                        />
                                    </td>

                                    {/* Settings (Delete button) */}
                                    <td className="p-0" style={{ height: '30px' }}>
                                        <span tyle={{ position: 'relative', top: '4px', height: '30px' }}>
                                            <GetIcon iconName="MdOutlineEdit" size={15} />
                                        </span>
                                    </td>


                                </tr>
                            );
                        })}
                    </tbody>
                </table>

                {/* Table controls */}
                <div className="d-flex pb-2 justify-content-between align-items-center">
                    <div className="d-flex" style={{ gap: '4px' }}>
                        {selectedRows.length > 0 && (
                            <Button
                                onClick={handleDeleteSelectedRows}
                                className="customdeletebtn"
                                iconName="MdDeleteOutline"
                                iconSize={12}
                            >
                                Delete
                            </Button>
                        )}

                        {/* <Button
                            onClick={handleAddRow}
                            className="Addrowdesign"
                            iconName="FiPlus"
                            iconSize={12}
                            iconWrapperStyle={{ backgroundColor: '#ff8d5c', padding: '1px', display: 'flex' }}
                        >
                            Add Row
                        </Button> */}

                        <Button
                            className="createbtn d-flex"
                            style={{ gap: '2px', height: '28px' }}
                            iconName="MdOutlineFileDownload"
                            iconSize={12}
                        >
                            Download
                        </Button>
                    </div>

                    {/* Pagination */}
                    <div className={`${rows.length < 11 ? "d-none" : "d-flex"} align-items-center centerpagination`} style={{ gap: '5px' }}>
                        <Pagination
                            setCurrentPage={setCurrentPage}
                            currentPage={currentPage}
                            pageSize={rowsPerPage}
                            totalrecords={rows.length}
                        />
                    </div>

                    <div className={`${rows.length < 11 ? "d-none" : "d-flex"}`}>
                        <span className="px-2" style={{ fontSize: '12px', color: '#270B79' }}>
                            Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, rows.length)} of {rows.length} entries
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Table1;